/**
 * Environment Configuration
 * Gateway-only mode for Dev Admin panel
 */

export const ENV = {
  // API
  API_URL: import.meta.env.VITE_API_URL,

  // App
  APP_NAME: import.meta.env.VITE_APP_NAME,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,

  // Feature flags
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,

  // Deployed environment identifier (development | production) — drives
  // dev-only tooling such as the BugPin widget. Defaults to production.
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT ?? 'production',

  // Gateway BFF Configuration (always gateway mode)
  GATEWAY_URL: import.meta.env.VITE_GATEWAY_URL?.replace(/\/$/, ''),
} as const
